import React from 'react';

import {
    BottomNavigation,
    Typography
} from '@mui/material';

import CopyrightIcon from "@mui/icons-material/Copyright"


export default function Footer(props) {

    return (
        <BottomNavigation>
            <Typography variant="h6"><CopyrightIcon /> 2024 - Athenos adviesgroep</Typography>
        </BottomNavigation>
    );
}
